import { Outlet } from "react-router";

/** Renders nested tenant-scoped routes via Outlet. */
const TenantLayout = () => <Outlet />;

export default TenantLayout;
